// https://www.digitalocean.com/community/tutorials/how-to-add-twitter-card-and-open-graph-social-metadata-to-your-webpage-with-html
// https://www.opengraph.xyz/url/https%3A%2F%2Falpha147.com

// https://developers.facebook.com/tools/debug/

import { MetaTagConfigs } from '@common/models';

const description = 'Alpha147 is a prototyping stack for quick iteration of ideas. It scales well.';

const ogImage = 'https://alpha147.com/assets/img/meta/alpha147-og.png';

export const sharedMetaTags: MetaTagConfigs = {
    description: {
        attribute: 'name',
        value: description,
    },
    ogDescription: {
        attribute: 'property',
        value: description,
    },
    ogImage: {
        attribute: 'property',
        value: ogImage,
    },
    ogImageAlt: {
        attribute: 'property',
        value: 'alpha147 - Adventure Driven',
    },
    ogImageHeight: {
        attribute: 'property',
        value: '630',
    },
    ogImageSecureUrl: {
        attribute: 'property',
        value: ogImage,
    },
    ogImageWidth: {
        attribute: 'property',
        value: '1200',
    },
    ogLocale: {
        attribute: 'property',
        value: 'en_US',
    },
    ogSiteName: {
        attribute: 'property',
        value: 'alpha147',
    },
    ogTitle: {
        attribute: 'property',
        value: 'alpha147',
    },
    ogType: {
        attribute: 'property',
        value: 'website',
    },
    ogURL: {
        attribute: 'property',
        value: 'https://alpha147.com/',
    },
    twitterCard: {
        attribute: 'name',
        value: 'summary_large_image',
    },
    twitterDomain: {
        attribute: 'property',
        value: 'alpha147.com',
    },
    twitterUrl: {
        attribute: 'property',
        value: 'https://alpha147.com',
    },
    twitterTitle: {
        attribute: 'name',
        value: 'alpha147',
    },
    twitterDescription: {
        attribute: 'name',
        value: description,
    },
    twitterImage: {
        attribute: 'name',
        value: ogImage,
    },
    twitterSite: {
        attribute: 'name',
        value: '@alpha147',
    },
};
